import { Button, Grid2 as Grid, Stack } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Section } from '@/components/Section';
import { ProjectCard } from '@/features/projects/ProjectCard';
import { usePublicProjects } from '@/features/projects/queries';
import { useSectionCopy } from './use-section-copy';

/** How many projects the home page teases before sending people to the full list. */
const TEASER_COUNT = 3;

/**
 * Reference projects, directly under the hero: proof of real work is the
 * strongest thing on the page. Renders nothing until one is published — an
 * empty "our work" band is worse than none.
 */
export function Projects() {
  const { t } = useTranslation();
  const { data: projects = [], isLoading } = usePublicProjects();
  const copy = useSectionCopy('projects', {
    eyebrow: t('projects.eyebrow'),
    title: t('projects.title'),
    subtitle: t('projects.subtitle'),
  });

  if (isLoading || projects.length === 0) return null;

  return (
    <Section id="referenzen" tone="muted" eyebrow={copy.eyebrow} title={copy.title} subtitle={copy.subtitle}>
      <Grid container spacing={3}>
        {projects.slice(0, TEASER_COUNT).map((project) => (
          <Grid key={project.id} size={{ xs: 12, sm: 6, md: 4 }}>
            <ProjectCard project={project} />
          </Grid>
        ))}
      </Grid>

      {projects.length > TEASER_COUNT && (
        <Stack direction="row" sx={{ mt: 4 }}>
          <Button
            component={RouterLink}
            to="/projekte"
            variant="outlined"
            color="inherit"
            size="large"
            endIcon={<ArrowForwardIcon />}
          >
            {t('projects.viewAll')}
          </Button>
        </Stack>
      )}
    </Section>
  );
}
